import { API_BASE_URL, getHeaders, handleResponse } from '../apiConfig';

export const fetchModuleAssessments = async (moduleId) => {
  const response = await fetch(`${API_BASE_URL}/assessments/module/${moduleId}`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const fetchAssessmentDetails = async (assessmentId) => {
  const response = await fetch(`${API_BASE_URL}/assessments/${assessmentId}`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const saveAssessment = async (assessmentData) => {
  const response = await fetch(`${API_BASE_URL}/assessments`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(assessmentData)
  });
  return handleResponse(response);
};

export const deleteAssessment = async (assessmentId) => {
  const response = await fetch(`${API_BASE_URL}/assessments/${assessmentId}`, {
    method: 'DELETE',
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const submitAssessmentAttempt = async (assessmentId, userAnswers) => {
  const response = await fetch(`${API_BASE_URL}/assessments/${assessmentId}/submit`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({ user_answers: userAnswers })
  });
  return handleResponse(response);
};

export const fetchAssessmentResults = async (assessmentId) => {
  const response = await fetch(`${API_BASE_URL}/assessments/${assessmentId}/results`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const copyAssessment = async (assessmentId, targetCourseId, targetModuleId) => {
  const response = await fetch(`${API_BASE_URL}/assessments/copy`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({
      assessment_id: assessmentId,
      target_course_id: targetCourseId,
      target_module_id: targetModuleId
    })
  });
  return handleResponse(response);
};

export const uploadQuestionImage = async (file) => {
  const formData = new FormData();
  formData.append('question_image', file);

  const token = localStorage.getItem('token');
  const response = await fetch(`${API_BASE_URL}/assessments/upload-image`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`
    },
    body: formData
  });
  return handleResponse(response);
};

export const fetchUserAssessmentAttempts = async (userId) => {
  const response = await fetch(`${API_BASE_URL}/assessments/user/${userId}/attempts`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const fetchMyAssessmentAttempts = async () => {
  const response = await fetch(`${API_BASE_URL}/assessments/my-attempts`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const fetchDashboardScheduledAssessments = async () => {
  const response = await fetch(`${API_BASE_URL}/assessments/scheduled-dashboard`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

